import packageJson from 'package.json';
import { ONLINE_CTA_TYPES } from '@pes-ui/utils/lib/constants';
import pesCLValidator from './utils/pes-country-language-validation/pes-country-language-validation';
import { isBrowser } from './utils/helpers';
window.pes = window.pes || {};
window.pes.validateCountryLanguage = pesCLValidator;
export const makeGetData = (packageName, packageVersion) => (data, rest, authorization) => {
  if (data) {
    return new Promise((resolve) => resolve(data));
  }
  const header = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'UIaaS-Component-Package': `${packageName}@${packageVersion}`,
  };
  if (authorization) {
    header.Autorization = authorization;
  }
  if (rest && isBrowser()) {
    return fetch(rest, {
      method: 'GET',
      mode: 'cors',
      headers: header,
    }).then((response) => {
      if (response.status === 200) {
        return response.json();
      }
      throw response.status;
    });
  }
  return new Promise((resolve) => resolve(null));
};
export const getData = makeGetData(packageJson.name, packageJson.version);
export const isEmpty = (object = {}) => Object.getOwnPropertyNames(object).length === 0;
export function isMobile() {
  if (!isBrowser())
    return true;
  const desktopBreakpoint = 980;
  return window.innerWidth < desktopBreakpoint;
}
export const parseJsonResponse = (resp) => resp.json();
export const parseJSONString = (str, defaultValue) => {
  try {
    return JSON.parse(str);
  }
  catch (e) {
    return defaultValue;
  }
};
export const isValidUrl = (url) => {
  try {
    new URL(url);
  }
  catch (_a) {
    return false;
  }
  return true;
};
export const transformCamelCaseString = (string = '', delimeter = '') => {
  return string.replace(/([a-z0-9])([A-Z])/g, `$1${delimeter}$2`).toLowerCase();
};
export const deepMerge = (target = {}, source) => {
  for (const key of Object.keys(source)) {
    if (Array.isArray(source[key])) {
      target[key] = [...source[key]];
    }
    else if (source[key] instanceof Object) {
      Object.assign(source[key], deepMerge(target[key], source[key]));
    }
  }
  Object.assign(target || {}, source);
  return target;
};
export const getDataAttributes = (dataset) => {
  if (!dataset) {
    return {};
  }
  return Object.keys(dataset).reduce((acc, key) => {
    acc[`data-${transformCamelCaseString(key, '-')}`] = dataset[key];
    return acc;
  }, {});
};
export const roundHalf = (num) => {
  return Math.round(num * 2) / 2;
};
export const convertToPx = (...values) => {
  return values.map((val) => `${val}px`).join(' ');
};
export const encodeProductId = (id) => encodeURIComponent(encodeURIComponent(id));
export const isTargetBlank = (target) => target === '_blank';
export const isLinkTypeOnline = (type) => type in ONLINE_CTA_TYPES;
export const sendEvent = (type, data) => {
  const customEvent = new CustomEvent(type, {
    detail: data,
  });
  window.dispatchEvent(customEvent);
};
export const getParamValueFromURL = (url, paramName) => {
  var _a;
  const regExp = new RegExp(`[?&](${paramName})=([^&]+).*$`);
  return (_a = url.match(regExp)) === null || _a === void 0 ? void 0 : _a[2];
};
export const getYouTubeVideoIDFromURL = (youTubeURL) => {
  const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
  const match = youTubeURL.match(regExp);
  return match && match[7].length === 11 ? match[7] : '';
};
export const urlDecode = (encodedString) => decodeURIComponent(encodedString.replace(/\+/g, ' '));
